<template>
    <o-form v-if="fetched" :item="changeOrderById(itemId)" />
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import OForm from './Form'

    export default {
        components: {
            OForm
        },

        data() {
            return {
                fetched: false
            }
        },

        computed: {
            ...mapGetters(['changeOrderById']),

            itemId() {
                return parseInt(this.$route.params.slug)
            },
        },

        mounted() {
            this.clearProjectServices()

            this.fetchChangeOrder(this.itemId)
                .then(res => {
                    this.fetched = true
                    return res
                })
        },

        methods: {
            ...mapActions(['fetchChangeOrder', 'clearProjectServices'])
        }
    }
</script>